import { Button, Input, InputNumber, Table, message } from 'antd';
import React, { Component } from 'react';
import API_URL from '../../../../common/url';
import $ from "../../../../common/AjaxRequest";
import '../index.less';

const PageConfig = {
    DetailedTotalPrice: {
        queryUrl: API_URL.evaluate.getQuotationVisitTotalDataList,
        saveUrl: API_URL.evaluate.updateQuotationVisitDetailTotalData,
    },
    SimpleTotalPrice: {
        queryUrl: API_URL.evaluate.getQuotationVisitTotalDataList,
        saveUrl: API_URL.evaluate.updateQuotationVisitSimpleTotalData,
    },
    FteSimpleTotalPrice: {
        queryUrl: API_URL.evaluate.getQuotationFteTotalDataList,
        saveUrl: API_URL.evaluate.updateQuotationFteSimpleTotalData,
    },
}

export default class QuotationTotalPrice extends Component {

    state = {
        config: [
            {title: '服务费', key: 'serviceFee'},
            {title: '第三方代垫费', key: 'reimbursedFee'},
            {title: '费用合计', key: 'totalFee'},
            {title: '税费', key: 'taxFee'},
            {title: '报价总价', key: 'totalQuotation'},
        ],
        type: 'view',
        priceName: '',
        remarkName: '',
        totalPaymentPlanAmount: '',  //付款计划合计金额
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { clinicalQuotationRecordId, activeKey } = this.props;
        if (!clinicalQuotationRecordId) return
        const options = {
            method: 'POST',
            url: PageConfig[activeKey].queryUrl,
            data: { 
                clinicalQuotationRecordId,
                isSimple: activeKey === 'DetailedTotalPrice' ? 0 : 1,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalPaymentPlanAmount } = res;
                const { config } = this.state;
                const { activeKey } = this.props;
                config.map((configData, configIndex) => {
                    (datas || []).map((resData, resIndex) => {
                        if (configIndex === resIndex) configData.list = resData;
                    });
                });
                //表格费用、备注字段名称
                const priceName = activeKey === 'DetailedTotalPrice' ?  'detailTotalPrice' : 'simpleTotalPrice';
                const remarkName = activeKey === 'DetailedTotalPrice' ? 'detailRemarks' : 'simpleRemarks';
                this.setState({ config, priceName, remarkName, totalPaymentPlanAmount });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const { type, priceName, remarkName } = this.state;
        const columns = [
            {
                title: '类别',
                dataIndex: 'typeName',
                key: 'typeName',
                width: 270,
            },
            {
                title: '费用',
                dataIndex: priceName,
                key: priceName,
                width: 180,
                render: (text, record, index) => {
                    const { totalDataType } = record;
                    const { totalPaymentPlanAmount } = this.state;
                    const canEdit = this.booleanEquals(totalDataType, [
                        'TOTAL_DATA_TYPE_DISCOUNT_RATE', 
                        'TOTAL_DATA_TYPE_TAX_RATE',
                    ]);
                    const textShow = (text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
                    const remarkYellow = totalDataType == 'TOTAL_DATA_TYPE_TOTAL_FEE_WITH_TAX' && text != totalPaymentPlanAmount;

                    return <div className={remarkYellow ? 'remark_yellow' : undefined}>
                        {canEdit ? ( type == 'edit' ? <span style={{width : '90%'}}>
                            <InputNumber
                                style={{width : '90%', marginRight : 5}}
                                className='custom-input-number '
                                min={0}
                                precision={2}
                                placeholder="请输入"
                                value={text}
                                onChange={value => this.handleChange(value, priceName, index, totalDataType)}
                            />%
                        </span> : ((text || text == 0) ? `${text}%` : '')) : textShow
                        }
                    </div>
                }
            },
            {
                title: '备注说明',
                dataIndex: remarkName,
                key: remarkName,
                width: 270,
                render: (text, record, index) => {
                    const { totalDataType } = record;
                    const canEdit = this.booleanEquals(totalDataType, [
                        'TOTAL_DATA_TYPE_SERVE_FEE', 
                        'TOTAL_DATA_TYPE_DISCOUNT_RATE',
                        'TOTAL_DATA_TYPE_SHARE_COST_FEE', 
                        'TOTAL_DATA_TYPE_SERVE_FEE_WITHOUT_SHARE_COST',
                        'TOTAL_DATA_TYPE_TAX_RATE', 
                        'TOTAL_DATA_TYPE_TOTAL_FEE_WITH_TAX',
                        'TOTAL_DATA_TYPE_EXPANSION_FEE', 
                    ]);
                    return canEdit ? ( type == 'edit' ? <Input
                            style={{width : '90%'}}
                            placeholder="请输入"
                            value={text}
                            onChange={e => this.handleChange(e.target.value, remarkName, index, totalDataType)}
                        /> : text) : text
                }
            },
        ];
        return columns
    }

    getDataSource = (data = [], show) => {
        const dataSource = [];
        //当折扣率为0时，隐藏部分字段
        data.map(el => {
            if (show) {
                dataSource.push({ ...el });
            } else {
                if (!this.booleanEquals(el.totalDataType, [
                    'TOTAL_DATA_TYPE_SHARE_COST_FEE', 
                    'TOTAL_DATA_TYPE_SERVE_FEE_WITHOUT_SHARE_COST',
                    'TOTAL_DATA_TYPE_TOTAL_FEE_WITHOUT_SHARE_COST', 
                ])) {
                    dataSource.push({ ...el });
                }
            }
        });
        return dataSource
    }

    //判断字段是否等于某些值
    booleanEquals = (key, value = []) => {
        return value.some((el) => key === el);
    };

    handleChange = (value, key, index, rowTotalDataType) => {
        const { config, priceName, remarkName } = this.state;
        const priceParams = {};  
        config.map(el => {
            el.list.map(listItem => {
                //将列表每行的费用数据放在一个对象里面
                if (listItem.totalDataType)priceParams[listItem.totalDataType] = listItem[priceName]
            })
        });
        if (key === priceName) {
             //折扣率值变化时
            if (rowTotalDataType == 'TOTAL_DATA_TYPE_DISCOUNT_RATE') {
                priceParams['TOTAL_DATA_TYPE_DISCOUNT_RATE'] = value;
                if (value) {
                    priceParams['TOTAL_DATA_TYPE_SHARE_COST_FEE'] = this.reservedForTwo(priceParams['TOTAL_DATA_TYPE_SERVE_FEE'] * priceParams['TOTAL_DATA_TYPE_DISCOUNT_RATE'] * 0.01); //津石分担成本=服务费小计*折扣率
                    priceParams['TOTAL_DATA_TYPE_SERVE_FEE_WITHOUT_SHARE_COST'] = this.reservedForTwo(priceParams['TOTAL_DATA_TYPE_SERVE_FEE'] - priceParams['TOTAL_DATA_TYPE_SHARE_COST_FEE'] ); //津石分担成本后服务费小计=服务费小计-津石分担成本
                    priceParams['TOTAL_DATA_TYPE_TOTAL_FEE_WITHOUT_SHARE_COST'] = this.reservedForTwo(priceParams['TOTAL_DATA_TYPE_SERVE_FEE_WITHOUT_SHARE_COST'] + priceParams['TOTAL_DATA_TYPE_PREPAID']); //费用合计（分担成本后）=津石分担成本后服务费小计+第三方代垫小计
                } else {
                    priceParams['TOTAL_DATA_TYPE_SHARE_COST_FEE'] = undefined;
                    priceParams['TOTAL_DATA_TYPE_SERVE_FEE_WITHOUT_SHARE_COST'] = undefined;
                    priceParams['TOTAL_DATA_TYPE_TOTAL_FEE_WITHOUT_SHARE_COST'] = undefined;
                }
            } else if (rowTotalDataType == 'TOTAL_DATA_TYPE_TAX_RATE') {
                priceParams['TOTAL_DATA_TYPE_TAX_RATE'] = value;
                //税率值变化时
                if (value) {
                    if (priceParams['TOTAL_DATA_TYPE_DISCOUNT_RATE'] > 0) {
                        priceParams['TOTAL_DATA_TYPE_TAXATION'] = this.reservedForTwo(priceParams['TOTAL_DATA_TYPE_TOTAL_FEE_WITHOUT_SHARE_COST'] * priceParams['TOTAL_DATA_TYPE_TAX_RATE'] * 0.01); //税费=费用合计（分担成本后）* 税率
                        priceParams['TOTAL_DATA_TYPE_TOTAL_FEE_WITH_TAX'] = this.reservedForTwo(priceParams['TOTAL_DATA_TYPE_TOTAL_FEE_WITHOUT_SHARE_COST'] + priceParams['TOTAL_DATA_TYPE_TAXATION']); //费用合计（含税）=费用合计（分担成本后）+ 税费
                    } else {
                        priceParams['TOTAL_DATA_TYPE_TAXATION'] = this.reservedForTwo(priceParams['TOTAL_DATA_TYPE_TOTAL_FEE'] * priceParams['TOTAL_DATA_TYPE_TAX_RATE'] * 0.01); //税费=费用合计（分担成本前）*税率
                        priceParams['TOTAL_DATA_TYPE_TOTAL_FEE_WITH_TAX'] = this.reservedForTwo(priceParams['TOTAL_DATA_TYPE_TOTAL_FEE'] + priceParams['TOTAL_DATA_TYPE_TAXATION']); //费用合计（含税）=费用合计（分担成本前）+ 税费
                    }
                    priceParams['TOTAL_DATA_TYPE_EXPANSION_FEE'] = this.reservedForTwo(priceParams['TOTAL_DATA_TYPE_TOTAL_FEE_AFTER_EXPANSION_WITH_TAX'] + priceParams['TOTAL_DATA_TYPE_TOTAL_FEE_WITH_TAX']); //通化膨胀费用=通化膨胀后总计（含税）+ 费用合计（含税）
                } else {
                    priceParams['TOTAL_DATA_TYPE_TAXATION'] = undefined;
                    priceParams['TOTAL_DATA_TYPE_TOTAL_FEE_WITH_TAX'] = undefined;
                    priceParams['TOTAL_DATA_TYPE_EXPANSION_FEE'] = undefined;
                }
            }
            //将priceParams对象的值赋回到config
            config.map(el => {
                el.list.map(listItem => {
                    if (listItem.totalDataType)listItem[priceName] = priceParams[listItem.totalDataType]
                })
            });
            if (rowTotalDataType == 'TOTAL_DATA_TYPE_DISCOUNT_RATE')this.handleChange(priceParams['TOTAL_DATA_TYPE_TAX_RATE'] , key, index, 'TOTAL_DATA_TYPE_TAX_RATE');//刷新受“费用合计”值变化的数据
        } else {
            config.map(el => {
                el.list.map(listItem => {
                    if (listItem.totalDataType === rowTotalDataType)listItem[remarkName] = value
                })
            });
        }
        this.setState({ config });
    }

    //保留两位小数
    reservedForTwo = value => {
        return Number(value.toFixed(2));
    }

    getContent = () => {
        const { config, priceName } = this.state;
        let show = true;  //判断折扣率是否为0
        config.map(configData => {
            (configData.list || []).map(listData => {
                if (listData.totalDataType == 'TOTAL_DATA_TYPE_DISCOUNT_RATE') {
                    show = !(listData[priceName] == 0 || !listData[priceName]);
                }
            });
        });
        const content = config.map((el, index) => <div style={{ marginBottom: 15 }}>
            <div style={{ marginBottom: 5, fontSize: 15, fontWeight: 900 }}>{el.title}</div>
                <Table
                    bordered
                    dataSource={this.getDataSource(el.list, show)}
                    columns={this.getColumns(index)}
                    pagination={false}
                />
            </div>);
        return content
    }

    submit = () => {
        const { activeKey, clinicalQuotationRecordId } = this.props;
        const { config } = this.state;
        const priceName = activeKey === 'DetailedTotalPrice' ? 'detailTotalPrice' : 'simpleTotalPrice';
        let sendData = {};
        let sendList = [];  //筛选发给后台值的数组
        (config || []).map(el => {
            sendList.push(...el.list);
        });
        //必填校验
        const discountRate = sendList.filter(el => el.totalDataType == "TOTAL_DATA_TYPE_DISCOUNT_RATE");
        const taxRate = sendList.filter(el => el.totalDataType == "TOTAL_DATA_TYPE_TAX_RATE");
        if ( discountRate[0][priceName] !== 0 && !discountRate[0][priceName]) {
            return message.warning('折扣率不能为空！');
        }
        if ( taxRate[0][priceName] !== 0 && !taxRate[0][priceName]) {
            return message.warning('税率不能为空！');
        }

        sendList.filter(el => el.totalDataType).map((el, index) => {
            sendData[`totalDataList[${index}].totalDataType`] = el.totalDataType;
            if (activeKey === 'DetailedTotalPrice') {
                sendData[`totalDataList[${index}].detailRemarks`] = el.detailRemarks;
            } else {
                sendData[`totalDataList[${index}].simpleRemarks`] = el.simpleRemarks;
            }

            if (el.totalDataType == 'TOTAL_DATA_TYPE_DISCOUNT_RATE' || el.totalDataType == 'TOTAL_DATA_TYPE_TAX_RATE') {
                if (activeKey === 'DetailedTotalPrice') {
                    sendData[`totalDataList[${index}].detailTotalPrice`] = el.detailTotalPrice;
                } else {
                    sendData[`totalDataList[${index}].simpleTotalPrice`] = el.simpleTotalPrice;
                }
            }
        });
        const options = {
            method: 'POST',
            url: PageConfig[activeKey].saveUrl,
            data: { quotationRecordId: clinicalQuotationRecordId, ...sendData },
            dataType: 'json',
            doneResult: res => {
                message.success('修改成功');
                this.setState({ type: 'view' }, () => {
                    this.loadData();
                });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { type } = this.state;
        const { recordData } = this.props;
        const { bdBaAuth, evaluateStatus } = recordData;
        return (
            <div>
                <div style={{ fontSize: 20, fontWeight: 600, textAlign: 'center', margin: '20px 0' }}>
                    费用汇总
                </div>
                { this.getContent() }
                { 
                    (bdBaAuth && evaluateStatus != 'STATE_PUBLISHED') && <div className='Forecast_Params_footer'>
                        {
                            type === 'view'?
                            <Button
                                type="primary"
                                onClick={() => this.setState({
                                    type: 'edit',
                                })}
                            >编辑</Button> :
                            <div>
                                <Button 
                                    style={{ marginRight: 20 }}
                                    onClick={() => this.setState({
                                        type: 'view',
                                    }, () => this.loadData())}
                                >取消</Button>
                                <Button 
                                    type="primary"
                                    onClick={this.submit}
                                >确定</Button>
                            </div>
                        }
                    </div>
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/QuotationTotalPrice.js